import React from 'react';
import {assetsPath} from '../../../../utils/utils';
import {Image} from '../../../../components/Image';

import './NearaFylla.scss';
import $appStore from '../../../../store/app/store';
import {useStore} from 'effector-react';

interface ICategory {
  item: any;
}

export const NearaFylla = (props: ICategory) => {
  const {item} = props;
  const appStore = useStore($appStore);

  return (
    <>
      {item.flatData.type === 'neara-fylla' && (
        <div
          id={item.flatData.friendlyUrl}
          className={`categorySection-texts ${
            item.flatData.type && item.flatData.type.replace(/\s/g, '-').toLowerCase()
          } `}
          style={{
            backgroundImage:
              item.flatData.backgroundImage !== null && item.flatData.backgroundImage[0]
                ? `url(${assetsPath}/${item.flatData?.backgroundImage[0].slug}`
                : 'none',
          }}
        >
          <div className="categorySection-inner">
            <div className="categorySection-inner-title">{item.flatData.title}</div>
            <div className="categorySection-inner-text" dangerouslySetInnerHTML={{__html: item.flatData.text}} />
            {item.flatData.icon && (
              <div className="categorySection-inner-icon">
                <Image
                  imageClass=""
                  config="cache=2630000"
                  imageUrl={
                    item.flatData.icon[0].flatData.icon &&
                    item.flatData.icon[0].flatData.icon.length > 0 &&
                    item.flatData.icon[0].flatData.icon.length > 1 &&
                    appStore.language === 'en'
                      ? item.flatData.icon[0].flatData.icon[1].slug
                      : item.flatData.icon[0].flatData.icon[0].slug
                    // item.flatData.icon[0].flatData.icon[0].slug
                  }
                />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
